var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2319 11.2711L11.8222 12.4534L10.4639 13.6356L11.8209 14.8167L11.8125 14.8178L21.2319 16L31.9999 14.8178V12.4534L21.2319 11.2711Z",
    fill: "#ECEFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2319 6.54227L11.8222 7.72445L10.4639 8.9067L11.8222 10.0889L21.2319 11.2711L31.9999 10.0889V7.72445L21.2319 6.54227Z",
    fill: "#ECEFF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8222 5.35992L10.4639 6.54224L11.8222 7.72442H31.9999V5.35992H11.8222Z",
    fill: "#1976D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 10.0889V10.0972L10.4639 11.2711L11.8125 12.445V12.4534H31.9999V10.0889H11.8125Z",
    fill: "#1976D2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.3644L0 19.5466V21.9111L16 23.0933L32 21.9111V19.5466L16 18.3644Z",
    fill: "#1976D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.0933L0 24.2755V26.64H32V24.2755L16 23.0933Z",
    fill: "#1976D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 14.8178V14.8262L10.4639 16L11.8125 17.1738V17.1821L21.8174 18.7943L31.9999 17.1821V14.8178H11.8125Z",
    fill: "#1976D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08856 5.36481H4.72406L0 10.0889V12.4534L4.72406 17.1774H7.08856L11.8126 12.4534V10.0889L7.08856 5.36481Z",
    fill: "#ECEFF1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08862 5.3648V10.0889H11.8126L11.8223 5.35992L7.08862 5.3648Z",
    fill: "#1976D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.35992V10.0889H4.72406V5.3648L0 5.35992Z",
    fill: "#1976D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8223 17.1822L11.8126 12.4534H7.08862V17.1774L11.8223 17.1822Z",
    fill: "#1976D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72406 17.1774V12.4534H0V17.1822L4.72406 17.1774Z",
    fill: "#1976D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32 21.9113H0V24.2758H32V21.9113Z",
    fill: "#ECEFF1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08219 17.1822L7.08856 17.1774L5.90631 16.2969L4.72406 17.1774L4.73037 17.1822H0V19.5466H32V17.1822H7.08219Z",
    fill: "#ECEFF1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr);
export default __webpack_public_path__ + "static/media/GR.25472320.svg";
export { ForwardRef as ReactComponent };